import { render, staticRenderFns } from "./App-v2.vue?vue&type=template&id=3f8ebdc1"
import script from "./App-v2.vue?vue&type=script&lang=ts&setup=true"
export * from "./App-v2.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./App-v2.vue?vue&type=style&index=0&id=3f8ebdc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports